import { useState } from 'react'
import { useLanguage } from '@shared/contexts/LanguageContext'
import { isYouTubeUrl, getYouTubeThumbnail } from '@shared/utils/videoUtils'
import GuardianExpoSubPageLayout from '../components/GuardianExpoSubPageLayout'
import LectureScheduleSection from '../components/LectureScheduleSection'
import ActivityVideosSection from '../components/ActivityVideosSection'
import PhotoGridSection from '../components/PhotoGridSection'
import ExpoVideoModal from '../components/ExpoVideoModal'
import { Lightbox } from '@shared/units/Lightbox'
import { lectureScheduleDays } from '../data/lectureSchedule'
import { useExpoMedia } from '../hooks/useExpoMedia'
import { EXPO_EVENT } from '../api/guardianExpoService'

export default function GuardianExpoLecturePage() {
  const { t } = useLanguage()
  const { videos, photos } = useExpoMedia(EXPO_EVENT.LECTURE)
  const [selectedVideo, setSelectedVideo] = useState(null)
  const [photoLightboxIndex, setPhotoLightboxIndex] = useState(null)

  return (
    <GuardianExpoSubPageLayout
      bannerSrc="/image/guardian-expo/banner_lecture_desktop.webp"
      bannerAlt={t('guardianExpo.lecture.pageTitle')}
      content={t('guardianExpo.lecture.introContent')}
    >
      <LectureScheduleSection
        titleBlack={t('guardianExpo.lecture.scheduleTitleBlack')}
        titleRed={t('guardianExpo.lecture.scheduleTitleRed')}
        days={lectureScheduleDays}
        first
      />

      {videos.length > 0 && <ActivityVideosSection
        videos={videos.map((video) => ({
          id: video.expo_media_id,
          thumbnail: video.media_url && isYouTubeUrl(video.media_url) ? getYouTubeThumbnail(video.media_url) : undefined,
          title: video.title,
          onClick: () => setSelectedVideo(video),
        }))}
      />}

      {photos.length > 0 && <PhotoGridSection
        titleBlack={t('guardianExpo.lecture.photosTitleBlack')}
        titleRed={t('guardianExpo.lecture.photosTitleRed')}
        photos={photos.map((photo) => ({ id: photo.expo_media_id, src: photo.media_url, alt: photo.title }))}
        onPhotoClick={(idx) => setPhotoLightboxIndex(idx)}
        last
      />}

      <ExpoVideoModal video={selectedVideo} onClose={() => setSelectedVideo(null)} />

      {photoLightboxIndex !== null && (
        <Lightbox
          images={photos.map((photo) => photo.media_url)}
          index={photoLightboxIndex}
          onIndexChange={setPhotoLightboxIndex}
          onClose={() => setPhotoLightboxIndex(null)}
        />
      )}
    </GuardianExpoSubPageLayout>
  )
}
